/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import { sortArrayByPriority } from "~utils/helpers";
import { getProductImage } from "~utils/shopify";

const ProductGrid = ({ className, products, sorting }) => {
  const { addToCart, inventoryCache, inventoryFetched } = useContext(
    AppContext
  );
  const { device } = useContext(DocumentContext);

  const [soldOutVariants, setSoldOutVariants] = useState([]);

  //

  const sortedProducts = JSON.parse(JSON.stringify(products));

  if (sortedProducts?.[0]) {
    sortArrayByPriority(sortedProducts);

    switch (sorting) {
      case `Lowest Price`:
        sortedProducts.sort((a, b) => {
          const priceA = a?.shopifyProduct?.variants?.[0]?.price;
          const priceB = b?.shopifyProduct?.variants?.[0]?.price;

          if (parseFloat(priceA) < parseFloat(priceB)) {
            return -1;
          }

          if (parseFloat(priceA) > parseFloat(priceB)) {
            return 1;
          }

          return 0;
        });

        break;

      case `Highest Price`:
        sortedProducts.sort((a, b) => {
          const priceA = a?.shopifyProduct?.variants?.[0]?.price;
          const priceB = b?.shopifyProduct?.variants?.[0]?.price;

          if (parseFloat(priceA) > parseFloat(priceB)) {
            return -1;
          }

          if (parseFloat(priceA) < parseFloat(priceB)) {
            return 1;
          }

          return 0;
        });

        break;

      default:
        break;
    }
  }

  /**
   * ---------------------------------------------------------------------------
   * useEffect [inventoryCache]
   * Reads the inventoryCache for live stock availability
   */

  useEffect(() => {
    if (!inventoryCache) {
      return;
    }

    const unstockedVariants = [];

    Object.keys(inventoryCache).forEach(variantId => {
      if (
        inventoryCache[variantId] !== null &&
        inventoryCache[variantId] <= 0
      ) {
        unstockedVariants.push(variantId);
      }
    });

    setSoldOutVariants(unstockedVariants);
  }, [inventoryCache]);

  //

  return (
    <ul className={`product-grid ${className} relative flex flex-wrap`}>
      {sortedProducts?.[0] &&
        sortedProducts.map((product, productIndex) => {
          const key = `${product.handle}-${productIndex}`;
          const soldOut = soldOutVariants?.includes(
            product?.shopifyProduct?.variants?.[0]?.id
          );

          //

          return (
            <li
              key={key}
              className={`product-grid__item animation-appear-right-slow w-1/2 md:w-1/3 relative flex flex-col items-stretch ${
                device === `desktop`
                  ? `mb-v4 pr-v05 pl-v05`
                  : `mt-3 mb-5 ${productIndex % 2 === 0 ? `pr-1` : `pl-1`}`
              }`}
              style={{
                animationDelay: `${
                  productIndex * 50 < 500 ? productIndex * 50 : 500
                }ms`
              }}
            >
              <Link
                to={`/products/${product.handle}`}
                className="product-grid__item__image relative overflow-hidden bg-light-bone"
              >
                <figure className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center">
                  {getProductImage(product)}
                </figure>
              </Link>

              <Link
                to={`/products/${product.handle}`}
                className="product-grid__item__text relative"
              >
                <h2
                  className={`hover-underline ${
                    device === `desktop` ? `mt-v1` : `mt-4`
                  } b2 italic`}
                >
                  {product.title}
                </h2>

                {product?.brands?.[0]?.title && (
                  <h3 className="b2">{product.brands[0].title}</h3>
                )}

                {product?.shopifyProduct?.variants?.[0]?.price && (
                  <h3 className={`${device === `desktop` ? `` : `mb-3`} b2`}>
                    ${product.shopifyProduct.variants[0].price}
                  </h3>
                )}
              </Link>

              <div className="w-full relative flex md:block mt-v1">
                {device !== `desktop` && (
                  <Link
                    to={`/products/${product.handle}`}
                    className={`${
                      product?.shopifyProduct?.variants?.[0]
                        ? `w-1/2`
                        : `w-full`
                    } relative block mr-1`}
                  >
                    <Button className="w-full relative block" color="white">
                      <span className="block caption">View</span>
                    </Button>
                  </Link>
                )}

                {(product?.shopifyProduct?.variants?.[0] && (
                  <Button
                    className={`w-1/2 md:w-full relative block ${
                      soldOut ? `opacity-25 pointer-events-none` : ``
                    } ml-1 md:ml-0`}
                    color={`${device === `desktop` ? `white` : `orange`}`}
                    onClick={() => {
                      if (!soldOut) {
                        addToCart({
                          ...product,
                          variant: product.shopifyProduct.variants[0]
                        });
                      }
                    }}
                  >
                    {(device === `desktop` && (
                      <span className="block f-button">
                        {soldOut ? `Sold out` : `Add to cart`}
                      </span>
                    )) || (
                      <span className="block caption">
                        {soldOut ? `Sold out` : `Add`}
                      </span>
                    )}
                  </Button>
                )) || (
                  <Button
                    className="w-full relative block opacity-25 pointer-events-none"
                    color="white"
                  >
                    <span className="f-button">
                      {device === `desktop` ? `Currently ` : ``}
                      Unavailable
                    </span>
                  </Button>
                )}
              </div>
            </li>
          );
        })}
    </ul>
  );
};

ProductGrid.defaultProps = {
  className: ``
};

ProductGrid.propTypes = {
  className: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default ProductGrid;
